import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Header.css";
import logo from "../../resources/evangadi-logo-home.png";
import { Link, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";

const Header = ({ scrolltoHow }) => {
    const [cookies, setCookie, removeCookie] = useCookies(null);
    const authToken = cookies.AuthToken;
    const buttonToggle = useRef();
    const navigate = useNavigate();
    const [show, setShow] = useState(true);

    const handlelogout = (e) => {
        e.preventDefault();
        removeCookie("AuthToken");
        removeCookie("username");
        removeCookie("email");
        navigate("/");
    };

    const handleButton = () => {
        setShow(!show);
    };

    const scrollHome = () => {
        window.scroll(0, 0);
    };

    return (
        <header className="navbar-header" id="top">
            <nav className={show ? "navbar navbar-expand-lg fixed-top" : "navbar navbar-expand-lg fixed-top opaBg"}>
                <div className="container padHeader">
                    {authToken ? (
                        <Link to="/" className="navbar-brand" onClick={scrollHome}>
                            <img src={logo} alt="" />
                        </Link>
                    ) : (
                        <Link to="/" className="navbar-brand" onClick={scrollHome}>
                            <img src={logo} alt="" />
                        </Link>
                    )}
                    <button className="navbar-toggler collapsed headerButton" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation" onClick={handleButton}>
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className={show ? "navbar-collapse collapse" : "toggleWidth"} id="navbarCollapse" ref={buttonToggle}>
                        <ul className="navbar-nav ms-auto">
                            <li className="nav-item active">
                                {authToken ? (
                                    <Link to="/" className="nav-link section-scroll" onClick={scrollHome}>
                                        Home
                                    </Link>
                                ) : (
                                    <Link to="/" className="nav-link section-scroll" onClick={scrollHome}>
                                        Home
                                    </Link>
                                )}
                            </li>
                            <li className="nav-item" onClick={scrolltoHow}>
                                {authToken ? (
                                    <Link to="/howitworks" data-scroll="" className="nav-link section-scroll">
                                        How it works
                                    </Link>
                                ) : (
                                    <Link data-scroll="" className="nav-link section-scroll">
                                        How it works
                                    </Link>
                                )}
                            </li>
                            <li>
                                <div className="connect-block">
                                    <Link to="#" className="lnk-toggler btn btn-blue text-white" id="headerSide" data-panel=".panel-login" onClick={authToken ? handlelogout : scrollHome}>
                                        {authToken ? "Log Out" : "Sign In"}
                                    </Link>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default Header;
